<template>
  <div v-show="!chartsReady " class="wait-wrapper">
    <div id="loading-visualization"><div class="lds-ring"><div /><div /><div /><div /></div></div>
  </div>
  <div v-show="chartsReady && Object.keys(chartsData).length > 0" id="wrapper" class="chart-wrapper scrollbar">
    <div v-for="chart in chartsData" :key="chart.name" class="chart-small">
      <TrainingChartSingle
        class="chart"
        :name="chart.name"
        :labels="chart.labels"
        :series="chart.series"
        @chart-clicked="chartZoomHandler(chart.name)"
      />
    </div>
  </div>
  <div v-show="chartsReady && Object.keys(chartsData).length ===0" id="wrapper" class="chart-wrapper scrollbar">
    <span class="warning-text">No charts to display</span>
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import TrainingChartSingle from '@/components/TrainerComponent/TrainerExperimentAndSessions/TrainingChartSingle';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

const $toast = useToast();

export default {
  name: 'TrainingCharts',
  components: {
    TrainingChartSingle,
  },
  props: {
    trainerSession: {
      type: Object,
      default: () => {},
    },
    projectID: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      dataConnect: new DatastoreConnect(),
      chartsReady: false,
      chartsData: {},
      controller: null,
    };
  },
  computed: {
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getChartsData();
    }, 10000);

    this.getChartsData();
  },
  unmounted() {
    this.controller.abort();
    clearInterval(this.interval);
  },
  methods: {
    async getChartsData() {
      this.fetchCharts().then(async (resp) => {
        const localChartsData = [];
        this.chartsReady = false;

        for (const [chartName, charts] of Object.entries(resp)) {
          const chart_data = {};
          const series = [];
          let labels = []; // final x-axis labels

          // Determine the longest label array
          for (const chart of charts) {
            if (chart.data.labels.length > labels.length) {
              labels = chart.data.labels;
            }
          }

          // Build series with x/y pairs
          for (const chart of charts) {
            const y = chart.data.series;

            // zip labels and series, pad with null if shorter
            const zippedData = labels.map((lx, i) => ({
              x: lx,
              y: y[i] ?? null, // use null if series is shorter than labels
            }));

            series.push({
              name: chart.id,
              data: zippedData,
            });
          }

          chart_data['series'] = series;
          chart_data['labels'] = labels;
          chart_data['name'] = chartName;

          localChartsData.push(chart_data);
        }

        this.chartsData = localChartsData;
        this.chartsReady = true;
      });
    },
    async fetchCharts() {
      this.controller = new AbortController();
      const currentController = this.controller;
      // Get Training Charts from BE
      const params = {
        project_id: this.projectID,
      };
      if (this.trainerExperiment == null) {
        params.session_id = this.trainerSession.id;
        params.trainer_id = this.trainerSession.trainer_id;
      } else {
        params.trainer_id = this.trainerExperiment.id;
      }

      const resp = await this.dataConnect.getCharts(params, currentController.signal)
        .catch((error) => {
          $toast.open({
            queue: true,
            dismissible: true,
            message: `Failed to retrieve charts: ${error}`,
            type: "error",
            position: "top",
          });
        });
      if (!resp || resp.error || !resp.result) {
        $toast.open({
          queue: true,
          dismissible: true,
          message: `Failed to retrieve charts: ${resp.error.message}`,
          type: "error",
          position: "top",
        });
        return {};
      }
      return resp.result;
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 8px;
  border-radius: 4px;
  align-content: start;
  overflow-y: scroll;
}

.chart-row {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 8px;
  align-content: start;
  overflow-x: scroll;
}

.wait-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  border: 4px;
}

.chart-small{
  border-radius: 8px;
  width: 600px;
  height: 350px;
  background-color: white;
  flex-grow: 1;

  margin: 8px;
}

.chart-full {
  width: 100%;
  height: 100%;
}

.chart{
  border: 4px;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);

}

.warning-text{
  font-size: 0.9rem;
}

</style>
